import React, {useEffect} from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {createBrowserRouter, Outlet, RouterProvider, useNavigate,} from "react-router-dom";
import ProjectSetting from "./routes/project/ProjectSetting";
import Lore from "./routes/story/Lore";
import {Provider} from 'react-redux'
import {store} from "./feature/store";
import {CookiesProvider, useCookies} from 'react-cookie';
import {ConfigProvider} from "antd";
import Project from "./routes/project/Project";
import Main from "./routes/Main";
import ProjectDetails from "./routes/project/ProjectDetails";
import StoryDetails from "./routes/story/StoryDetails";
import Setting from "./routes/story/Setting";
import ActDetails from "./routes/act/ActDetails";
import ChapterDetails from "./routes/chapter/ChapterDetails";
import SceneDetails from "./routes/scene/SceneDetails";
import ShotDetails from "./routes/shot/ShotDetails";
import {Login} from "./routes/auth/Login";
import {Register} from "./routes/auth/Register";
import {StoryTool, storyTools} from "./routes/story/tools/StoryTool";
import {RouteObject} from "react-router/dist/lib/context";


const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

export const pathMap = [
    {
        title: 'Main',
        id: '0',
    },
    {
        title: 'Project',
        id: '1',
    },
    {
        title: 'ProjectDetails',
        id: '1-1',
    },
    {
        title: 'Project Settings',
        id: '1-2',
    },
    {
        title: 'Stories',
        id: '1-3',
    },
    {
        title: 'Stories',
        id: '1-3-1',
    },
    {
        title: 'Story',
        id: '1-3-2',
    },
    {
        title: 'Setting',
        id: '1-3-2-2',
    },
    {
        title: 'Lore',
        id: '1-3-2-3',
    },
    {
        title: 'Global Setting',
        id: '1-4',
    },
    {
        title: 'Story Setting',
        id: '1-3-2-2-1',
    },
    {
        title: 'Story Lore',
        id: '1-3-2-3-1',
    },
    {
        title: 'Act',
        id: '1-3-2-4',
    },
]

const toolsRoutes = storyTools.map((tool: StoryTool) => (
        tool.paths.map((path: string, index: number) => ({
            path: path,
            element: tool.entryPoint,
            id: tool.id + "-" + index,
        } as RouteObject))
    )
).flat()

// @ts-ignore
const router = createBrowserRouter([
        {
            path: "/",
            element: <Main/>,
            id: '0',
        },
        {
            path: "/projects/:projectId",
            element: <Project/>,
            id: '1',
            children: [
                {
                    path: "/projects/:projectId",
                    element: <ProjectDetails/>,
                    id: '1-1',
                },

                {
                    path: "/projects/:projectId/stories/:storyId",
                    element: <Outlet/>,
                    id: '1-3-2',
                    children: [
                        {
                            path: "/projects/:projectId/stories/:storyId",
                            element: <StoryDetails/>,
                            id: '1-3-2-1',
                            children: [
                                {
                                    path: "/projects/:projectId/stories/:storyId/setting",
                                    element: <Setting/>,
                                    id: '1-3-2-2',
                                    children: [
                                        {
                                            path: "/projects/:projectId/stories/:storyId/setting/components/:componentId",
                                            element: <></>,
                                            id: '1-3-2-2-1',
                                        }
                                    ]
                                },
                                {
                                    path: "/projects/:projectId/stories/:storyId/lore",
                                    element: <Lore/>,
                                    id: '1-3-2-3',
                                    children: [
                                        {
                                            path: "/projects/:projectId/stories/:storyId/lore/components/:componentId",
                                            element: <></>,
                                            id: '1-3-2-3-1',
                                        }
                                    ]
                                },
                                {
                                    path: "/projects/:projectId/stories/:storyId/acts/:actId",
                                    element: <ActDetails/>,
                                    id: '1-3-2-4',
                                    children: [
                                        {
                                            path: "/projects/:projectId/stories/:storyId/acts/:actId/chapters/:chapterId",
                                            element: <ChapterDetails/>,
                                            id: '1-3-2-5',
                                            children: [
                                                {
                                                    path: "/projects/:projectId/stories/:storyId/acts/:actId/chapters/:chapterId/scenes/:sceneId",
                                                    element: <SceneDetails/>,
                                                    id: '1-3-2-6',
                                                    children: [
                                                        {
                                                            path: "/projects/:projectId/stories/:storyId/acts/:actId/chapters/:chapterId/scenes/:sceneId/shots/:shotId",
                                                            element: <ShotDetails/>,
                                                            id: '1-3-2-7'
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                //@ts-ignore
                            ].concat(toolsRoutes)
                        }
                    ]
                },
                {
                    path: "/projects/:projectId/setting",
                    element: <ProjectSetting/>,
                    id: '1-4',
                    children: [
                        {
                            path: "/projects/:projectId/setting/components/:componentId",
                            element: <></>,
                            id: '1-4-1',
                        }
                    ]
                },
            ]
        },
        {
            path: "/sign-in",
            element: <Login />,
            id: '2',
        },
        {
            path: "/sign-up",
            element: <Register />,
            id: '3',
        },
    ], {
        future: {
            v7_skipActionErrorRevalidation: true,
            v7_fetcherPersist: true,
            v7_relativeSplatPath: true,
            v7_normalizeFormMethod: true,
            v7_partialHydration: true,
        },
    })
;


root.render(
    <ConfigProvider theme={{token: {fontFamily: 'Nunito, sans-serif',}}}>
        <CookiesProvider>
            <Provider store={store}>
                {/*<React.StrictMode>*/}
                    <RouterProvider router={router} future={{
                        v7_startTransition: true,
                    }}/>
                {/*</React.StrictMode>*/}
            </Provider>
        </CookiesProvider>
    </ConfigProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
